import { BOGeneralValues } from "./BOGeneralValues.model";

export class BOPatientAllergies extends BOGeneralValues{
    id:number;
    tempId?:string;
    patientId:number;
    allergyType:string;
    allergyName:string;
    allergen:string;
}
